/**
 * DTO's
 */
export const DietaryMaterialModelToAlternativeMaterialManage = (
	model: IDietMaterialModel,
	component: IDietaryAlternativeMaterialManageComponent,
	order: number,
): IDietaryAlternativeMaterialManage => {
	const { id, name, internalName } = model

	return {
		order,
		internalName,
		id: null,
		name: name.pl,
		netWeight: component.netWeight,
		alternativeMaterialId: id,
		originalMaterialId: component.id,
		groupId: component.groupId ?? null,
		type: EDietSharedComponentType.MATERIAL,
	}
}

export const DietaryComponentsRawMaterialModelToAlternativeMaterialManage = (
	model: IDietComponentsRawMaterialModel,
	component: IDietaryAlternativeMaterialManageComponent,
	order: number,
): IDietaryAlternativeMaterialManage => {
	const { id, name, internalName } = model

	return {
		order,
		internalName,
		id: null,
		name: name.pl,
		netWeight: component.netWeight,
		alternativeMaterialId: id,
		originalMaterialId: component.id,
		groupId: component.groupId ?? null,
		type: EDietSharedComponentType.MATERIAL,
	}
}

export const DietaryRawMaterialAlternativeDetailsToModel = (
	json: IDietaryRawMaterialAlternativeDetails,
): IDietaryRawMaterialAlternativeDetailsModel => {
	const { id, name_trans, internal_name, warehouse_name } = json

	return {
		id,
		name: name_trans,
		internalName: internal_name,
		warehouseName: warehouse_name,
	}
}

export const DietaryRawMaterialAlternativeToAlternativeMaterialManage = (
	original: { id: number },
	alternative: IDietaryRawMaterialAlternativeModel,
	groupId?: number | null,
): IDietaryAlternativeMaterialManage => {
	const { netWeight, order, alternativeRawMaterial } = alternative

	return {
		netWeight,
		id: alternativeRawMaterial.id,
		name: alternativeRawMaterial.name,
		internalName: alternativeRawMaterial.internalName,
		originalMaterialId: original.id,
		alternativeMaterialId: alternativeRawMaterial.id,
		order: order ?? undefined,
		groupId: groupId ?? null,
		type: EDietSharedComponentType.MATERIAL,
	}
}

/**
 * Payloads
 */
export const DietaryAlternativeMaterialManageToSemiProductPayload = (
	data: IDietaryAlternativeMaterialManage,
): IDietaryAlternativeSemiProductPayload => {
	const { alternativeMaterialId, netWeight, order } = data

	return {
		id: alternativeMaterialId,
		net_weight: netWeight,
		order: order ?? null,
	}
}
